import { SvgIconProps } from "@mui/material";

export const FemaleIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 9a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
    <path d="M12 14v7" />
    <path d="M9 18h6" />
  </svg>
);
